// src/pages/ProjectDetail.js
import { useParams } from 'react-router-dom';
import projects from '../data/projects';

function ProjectDetail() {
  const { id } = useParams();
  const project = projects.find(p => p.id === id);

  if (!project) {
    return <p>Project not found</p>;
  }

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-white py-12 px-6 transition-colors duration-300">
                <h1 className="text-4xl font-bold text-center mb-10">{project.title}</h1>
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* Left Column */}
        <div className="space-y-10">
        <img
            src={project?.image || "https://source.unsplash.com/800x400/?web,design"}
            alt="Blog Cover"
            className="rounded-2xl shadow-lg w-full h-64 object-cover"
          />
          <div>
            <h2 className="text-xl font-bold mb-2">Summary</h2>
            <p>
              {project.shortDescription}
            </p>
          </div>
          <div>
            <h2 className="text-xl font-bold mb-2">Tools & Technologies Used</h2>
            <p>{project.usedTools}</p>
          </div>
        </div>

        {/* Right Column (spans 2 columns on medium screens and up) */}
        <div className="md:col-span-2 space-y-6">
          <div className="space-y-4">
            {(project?.fullDescription || `Lorem ipsum dolor sit amet, consectetur adipiscing elit. 
            Nihil vel illum asperiores dignissimos cumque quibusdam et fugiat voluptatem nobis suscipit explicabo, 
            eaque consequatur nesciunt, fugit eligendi corporis laudantium adipisci soluta?`).split('\n').map((para, index) => (
              <p key={index} className="text-gray-700 dark:text-gray-300 leading-relaxed">
                {para}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectDetail;


